import React, { Component } from 'react';
import Dropzone from 'react-dropzone';

import { withStyles } from '@mui/styles';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';

import { Tab, Tabs, Paper, Button, TextField, LinearProgress } from '@mui/material';

import ModalTransition from './ModalTransition';

import request from 'superagent';

class UploadForm extends Component {
  state = {
    progress: 0,
    uploadFromUrlValue: '',
    loaded: true,
    tabValue: 0,
    error: '',
    statusListener: 0,
    uploadedImgs: [],
  };

  onInputChange = (key, value) => {
    this.setState({ [key]: value });
  };

  onDrop = (files) => {
    this.setState({ loaded: false, error: '' });

    const { fields, uploadUrl } = this.props;
    const { statusListener } = this.state;

    request
      .post(uploadUrl)
      .field(fields)
      .attach('image', files[0])
      .then(() => {
        this.setState({ progress: 100 }, (data) => {
          clearInterval(progressInterval);
        });
      });

    let statusListenerId;

    if (!statusListener) {
      statusListenerId = setInterval(() => {
        request.get('/uploadimage').then((res) => {
          const data = JSON.parse(res.text);

          if (data && data.status === 2) {
            clearInterval(statusListener || statusListenerId);

            const { uploadedImgs } = this.state;

            uploadedImgs.push({
              url: data.fileUrl,
              name: data.fileName,
            });

            this.setState({ statusListener: 0, uploadedImgs, loaded: true }, () => {
              this.onClose();
            });
          } else if (data.desk && data.status === 3) {
            this.setState({ error: data.desk });
            clearInterval(statusListener || statusListenerId);
            this.setState({ statusListener: 0, loaded: true });
          }
        });
      }, 1000);
    }

    if (statusListenerId) this.setState({ statusListener: statusListenerId });

    const progressInterval = setInterval(() => {
      const { progress } = this.state;

      if (progress <= 100) {
        request.get('/uploadimage').then((res) => {
          const data = JSON.parse(res.text);

          if (data && data.status === 2) {
            clearInterval(statusListener || statusListenerId);

            const { uploadedImgs } = this.state;

            uploadedImgs.push({
              url: data.fileUrl,
              name: data.fileName,
            });

            this.setState({ statusListener: 0, uploadedImgs, loaded: true }, () => {
              this.onClose();
            });
          }

          this.setState({ progress: data.percent });
        });
      }
    }, 400);
  };

  uploadByLink = () => {
    const { uploadFromUrlValue } = this.state;

    this.setState({ loaded: false });

    const { fields, uploadUrl } = this.props;
    const { statusListener } = this.state;

    request
      .post(uploadUrl)
      .field(fields)
      .field('linkHttp', uploadFromUrlValue)
      .then(() => {
        this.setState({ progress: 100 }, () => {
          clearInterval(progressInterval);
        });
      });

    let statusListenerId;

    if (!statusListener) {
      statusListenerId = setInterval(() => {
        request.get('/uploadimage').then((res) => {
          const data = JSON.parse(res.text);

          if (data && data.status === 2) {
            clearInterval(statusListener || statusListenerId);

            const { uploadedImgs } = this.state;

            uploadedImgs.push({
              url: data.fileUrl,
              name: data.fileName,
            });

            this.setState({ statusListener: 0, uploadedImgs, loaded: true }, () => {
              this.onClose();
            });
          } else if (data.desk && data.status === 3) {
            this.setState({ error: data.desk });
            clearInterval(statusListener || statusListenerId);
            this.setState({ statusListener: 0, loaded: true });
          }
        });
      }, 1000);
    }

    if (statusListenerId) this.setState({ statusListener: statusListenerId });

    const progressInterval = setInterval(() => {
      const { progress } = this.state;

      if (progress <= 100) {
        request.get('/uploadimage').then((res) => {
          const data = JSON.parse(res.text);

          if (data && data.status === 2) {
            clearInterval(statusListener || statusListenerId);

            const { uploadedImgs } = this.state;

            uploadedImgs.push({
              url: data.fileUrl,
              name: data.fileName,
            });

            this.setState({ statusListener: 0, uploadedImgs }, () => {
              this.onClose();
            });
          }

          this.setState({ progress: data.percent });
        });
      }
    }, 400);
  };

  onClose = () => {
    const { statusListener, uploadedImgs } = this.state;
    const { onClose, updateParentData } = this.props;

    clearInterval(statusListener);

    updateParentData(uploadedImgs);
    onClose();

    this.setState({
      uploadedImgs: [],
      uploadFromUrlValue: '',
      progress: 0,
      loaded: true,
      error: '',
    });
  };

  render() {
    const { loaded, uploadFromUrlValue, tabValue, error } = this.state;
    const { classes, multiple, isOpen, acceptTypes } = this.props;

    const dropzoneRef = React.createRef();

    return (
      <Dialog
        open={isOpen}
        //onClose={this.onClose}
        onClose={(event, reason) => {

          if(reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
              // Set 'open' to false, however you would do that with your particular code.
              //setOpen(false);
              this.onClose();
          } else {
            this.onClose();
          }
      }}
        // disableBackdropClick={!loaded}
        // disableEscapeKeyDown={!loaded}
        TransitionComponent={ModalTransition}
      >
        <DialogContent>
          <Paper>
            <Tabs
              variant="fullWidth"
              value={tabValue}
              indicatorColor="primary"
              disabled={!loaded}
              textColor="primary"
              onChange={(e, tabValue) => {
                this.setState({ tabValue, error: '' });
              }}
            >
              <Tab label="Upload" />
              <Tab label="By URL" />
            </Tabs>
          </Paper>

          <div
            disabled={!loaded}
            style={{
              display: 'flex',
              width: '500px',
              height: '25vh',
              paddingTop: '30px',
            }}
          >
            {tabValue === 0 ? (
              <Dropzone
                ref={dropzoneRef}
                multiple={multiple || false}
                disabled={!loaded}
                onDrop={this.onDrop}
                onFileDialogCancel={this.onCancel}
                accept={acceptTypes === '*/*' || !acceptTypes ? '' : acceptTypes}
                className={`${!loaded ? classes.dropzoneDisabled : ''} ${classes.dropzone}`}
              >
                {/* <span>Click to upload or drop file(s) in this area</span> */}
                {({getRootProps, getInputProps}) => (
                  <section {...getRootProps({ className: 'dropzone' })} className={classes.dropzone}>
                      <input {...getInputProps()} />
                      <p>Drag 'n' drop some file here, or click to select file</p>
                  </section>
                )}
              </Dropzone>
            ) : (
              <TextField
                fullWidth
                placeholder="http://..."
                value={uploadFromUrlValue}
                onChange={(e) => this.onInputChange('uploadFromUrlValue', e.target.value)}
              />
            )}
          </div>

          {!loaded ? (
            <div style={{ marginTop: '20px' }}>
              <LinearProgress variant="determinate" value={this.state.progress} />
            </div>
          ) : null}

          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '20px',
            }}
          >
            <Button
              color="primary"
              variant="contained"
              style={{ marginLeft: '10px' }}
              disabled={!loaded}
              onClick={() => {
                if (tabValue === 0) {
                  dropzoneRef.current.open();
                } else {
                  this.uploadByLink();
                }
              }}
            >
              Upload
            </Button>
          </div>

          {error ? <p style={{ color: 'red' }}>Error: {error}</p> : null}
        </DialogContent>
      </Dialog>
    );
  }
}

const styles = {
  dropzone: {
    width: '100%',
    border: '3px dotted gray',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '14px',
    color: 'gray',
    fontWeight: 'bold',
    '&:hover': {
      color: '#3f51b5',
      borderColor: '#3f51b5',
      cursor: 'pointer',
    },
  },
  dropzoneDisabled: {
    '&:hover': {
      cursor: 'not-allowed',
      color: 'gray',
      border: '3px dotted gray',
    },
  },
};

export default withStyles(styles)(UploadForm);
